import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MultiSelectProps } from './multi-select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';

export function MultiSelectFew<T>(props: MultiSelectProps<T>) {
  const { selected, itemValue, onChange, selectables, itemLabel, renderValue } =
    props;

  // Memoize the value array to ensure stability
  const selectedValues = React.useMemo(
    () => selected.map((s) => itemValue(s)),
    [selected, itemValue],
  );

  const handleChange = React.useCallback(
    (e: { target: { value: unknown } }) => {
      // Material-UI Select with multiple returns an array
      const value = e.target.value;
      // Ensure we always pass an array
      const newValues = Array.isArray(value) ? value : [value];
      onChange(newValues as string[]);
    },
    [onChange],
  );

  return (
    <Select
      multiple
      value={selectedValues}
      onChange={handleChange}
      renderValue={renderValue}
      sx={{ backgroundColor: 'white' }}
    >
      {selectables.map((selectable) => {
        const selectableId = itemValue(selectable);
        const isSelected = selectedValues.includes(selectableId);
        return (
          <MenuItem key={selectableId} value={selectableId}>
            <Checkbox checked={isSelected} color="info" />
            <ListItemText primary={itemLabel(selectable)} />
          </MenuItem>
        );
      })}
    </Select>
  );
}
